import React from 'react';

const Tag = ({color = 'blue', text, className, dot = true}) => {
    return (
        <div className={`tag ${color} ${className || ''} ${dot ? 'dot' : ''}`}>{text}</div>
    );
}

export default Tag;